/**
 * Information Dialog 
 *
 * Independent dialog, can display any content what you will pass in.
 * It exposes self Refs, so can be opened by any other component 
 * which attach will attach to it.
 * 
 * Docs:
 * https://material-ui.com/demos/dialogs/
 * https://reactjs.org/docs/refs-and-the-dom.html
 *
 * @example
 *        import Button from '@material-ui/core/Button';
 *        import DialogInfo from './DialogInfo';
 *
 *        class SampleParentComponent extends React.Component {
 *
 *          handleDialogOpen = event => {
 *            this.dialog.handleDialogOpen();
 *          };
 *
 *          render() {
 *            return (
 *              <div>
 *                <Button onClick={this.handleDialogOpen}/>
 *                  Open Dialog
 *                </Button>
 *                <DialogInfo onRef={ref => (this.dialog = ref)} >
 *                  This is an informative dialog.
 *                </DialogInfo>
 *              </div>
 *            );
 *          }
 *        };
 */

import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

class DialogInfo extends React.Component {
  state = {
    open: false,
  };
  
  handleDialogOpen = event => {
    this.setState({ open: true });
  };

  handleDialogClose = () => {
    this.setState({ open: false });
  };

  componentDidMount() {
    this.props.onRef(this)
  }
  componentWillUnmount() {
    this.props.onRef(undefined)
  }
  render() {
    return (
      <Dialog
        open={this.state.open}
        onClose={this.handleDialogClose}
        scroll="paper"
      >
        <DialogContent>
          {this.props.children}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleDialogClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default DialogInfo;